import { render, staticRenderFns } from "./DataTableHedgeCommodities.vue?vue&type=template&id=b8e1ec9e&"
import script from "./DataTableHedgeCommodities.vue?vue&type=script&lang=js&"
export * from "./DataTableHedgeCommodities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports